import { db } from '@/firebase'
import firebase from 'firebase/app'
// import axios from 'axios'
// import router from '@/router'

export default {

    async getProducts () {
        try {
            const productsList = []
            await firebase
                .firestore()
                .collection('products')
                .get().then(querySnapshot => {
                    querySnapshot.forEach(document => {
                      const data = document.data()
                      const product = {
                        id: document.id,
                        name: data.name,
                        price: data.price,
                        description: data.description,
                        quantity: data.quantity,
                        visible: data.visible,
                      }
                      productsList.push(product)
                    })
                  })

                  return productsList
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async isTutorExist (email) {
      try {
        const isExist = await db.collection('users').where('email', '==', email).where('type', '==', 'tutor').get()
        return isExist.empty
      } catch (error) {
        console.log(error)
        return true
      }
    },

}
